import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { armarParametros } from "../../helpers/parametros";
import { startSpinner,finishSpinner } from "../ui/spinner";
import { TIPO_PARAMETRIZACION_TURNOS } from "../../utils/constants";

export const efectorHorariosTraerStart = () => ({ type: types.efectorHorariosTraerStart });
export const efectorHorariosLimpiar = () => ({ type: types.efectorHorariosLimpiar });
export const efectorHorariosTraerError = (error) => ({ type: types.efectorHorariosTraerError, payload: error});
export const efectorHorarioSeleccionar = (error) => ({ type: types.efectorHorarioSeleccionar, payload: error});
export const efectorHorariosUpdateDisabled = (payload) => ({ type: types.efectorHorariosUpdateDisabled, payload: payload});
export const efectorHorariosModificarInHabilitado = (payload) => ({ type: types.efectorHorariosModificarInHabilitado, payload: payload});
export const efectorHorariosInHabilitarGenerar = (payload) => ({ type: types.efectorHorariosInHabilitarGenerar, payload: payload});
export const efectorHorariosTraerSuccess = (payload) => {
    return {
        type: types.efectorHorariosTraerSuccess,
        payload: payload
    }
}
export const efectorHorariosDemandaTraerSuccess = (payload) => {
  return {
      type: types.efectorHorariosDemandaTraerSuccess,
      payload: payload
  }
}
export const efectorEspecialidadesDemandaTraerSuccess = (payload) => {
  return {
      type: types.especialidadesHorarioDemandaTraerSuccess,
      payload: payload
  }
}
export const HorariosMedicosTraerSuccess = (payload) => {
  return {
      type: types.horariosMedicosTraerSuccess,
      payload: payload
  }
}

export const fetchEfectorHorarios = (idCentroMedico, idProfesional, idEspecialidad, idTipoParametrizacion) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(efectorHorariosTraerStart());
        const parametros = armarParametros(idEspecialidad, idCentroMedico, idProfesional, null, null, null, null, idTipoParametrizacion);
        const response = await fetchConToken(`EfectorHorarios/traer?${parametros}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(efectorHorariosTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};


export const fetchEfectorHorariosPorProfesionalFecha = (idProfesional, fecha, demanda) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const parametros = armarParametros(null, null, idProfesional, null, null, fecha, null, null, true, demanda);
      const response = await fetchConToken(`EfectorHorarios/traerPorProfesionalFecha?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(efectorHorariosDemandaTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchHorariosDemandaDisponibles = (idEspecialidad) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const parametros = armarParametros(idEspecialidad, null, null, null, null, null, null, null, true );
      const response = await fetchConToken(`EfectorHorarios/traerHorariosDemandaDisponibles?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        if(idEspecialidad) 
          dispatch(efectorHorariosDemandaTraerSuccess(lista));
        else
          dispatch(efectorEspecialidadesDemandaTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchEfectorHorariosPorProfesional = (idProfesional) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const parametros = armarParametros(null, null, idProfesional, null, null, null, null, null, true );
      const response = await fetchConToken(`EfectorHorarios/traerPorProfesional?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(efectorHorariosTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const agregarEfectorHorario = (parametros, dias) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const response = await fetchConToken(`EfectorHorarios`, {parametros, dias}, 'POST');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(efectorHorariosTraerSuccess(lista));
        dispatch(efectorHorariosUpdateDisabled(true));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const modificarPisoConsultorio = (parametros) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      //dispatch(efectorHorariosTraerStart());
      const response = await fetchConToken(`EfectorHorarios/editarPisoConsultorio`, parametros, 'PUT');
      const body = await response.json();
      if (response.ok) {
        dispatch(
          startAlerta(
            'Modificado correctamente',
            'success',
            'Comando Exitoso',
          ),
        );
      dispatch(fetchEfectorHorarios(parametros.idCentro, parametros.idEfector, parametros.idEspecialidad, TIPO_PARAMETRIZACION_TURNOS.NORMAL))
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const habilitarInhabilitarEfectorHorario = (idEfHorario, inHabilitado) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`EfectorHorarios/editarInHabilitado`, {idEfHorario, inHabilitado}, 'PUT');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
          const item = await response.json();
          if (response.status !== 200) throw item.errores;

          dispatch( efectorHorariosModificarInHabilitado({idEfHorario, inHabilitado}) );
      }
      dispatch(finishSpinner());
    } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const generarTurnosPorEfectorHorario = (idEfHorario) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`EfectorHorarios/generarTurnos`, {idEfHorario}, 'PUT');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
          const item = await response.json();
          if (response.status !== 200) throw item.errores;

          dispatch( efectorHorariosInHabilitarGenerar(idEfHorario) );
      }
      dispatch(finishSpinner());
    } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const agregarEquivalenciaNroMedicoOspe = (idEfectorP, idCentroMedico, idEspecialidad, nroMedicoOspe, callBack, callback2) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const response = await fetchConToken(`RelEfectorOspe`, {idEfectorP, idCentroMedico, idEspecialidad, nroMedicoOspe}, 'POST');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        callBack&& callBack();
        callback2&& callback2();
      }
      dispatch(finishSpinner());
    } catch (err){
      console.log( err );
      dispatch(finishSpinner());
      dispatch(startAlerta('Error al generar la equivalencia con el usuario de Ospe', "warning", `¡Error!`));
    }
  };
};

export const fetchHorariosMedicos = (idCentroMedico, idProfesional, idEspecialidad) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const parametros = armarParametros(idEspecialidad, idCentroMedico, idProfesional, null, null, null, null, null);
      const response = await fetchConToken(`HorariosMedicos/traer?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(HorariosMedicosTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};


export const agregarHorariosMedicos = (parametros, dias) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const response = await fetchConToken(`HorariosMedicos`, {parametros, dias}, 'POST');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(HorariosMedicosTraerSuccess(lista));
        dispatch(efectorHorariosUpdateDisabled(true));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const eliminarHorariosMedicos = (parametros, dias) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectorHorariosTraerStart());
      const response = await fetchConToken(`HorariosMedicos`, {parametros}, 'DELETE');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(fetchHorariosMedicos(parametros.idCentro, parametros.idEfector, parametros.idEspecialidad));
        dispatch(efectorHorariosUpdateDisabled(true));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

